import "./FileManager2.scss"
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {FileManagerTypes, fileTypes} from "../../component/fileManager/FileManager";
import {css} from "@emotion/css";
import {FileManagerService} from "../../component/fileManager/FileManagerService";
import MediaItemsModel from "./mediaItemsPicture/MediaItemsModel";
import MediaItemShimmer from "./mediaItemShimmer/MediaItemShimmer";
import UploadVideoFile from "./uploadVideoFile/UploadVideoFile";
import UploadImageFile from "./uploadImageFile/UploadImageFile";
import UploadAudioFile from "./uploadAudioFile/UploadAudioFile";
import {
    DialogSize,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoLabel,
    showErrorMessage,
    RaikoTableTitleContainer,
    RaikoErrorSection,
    RaikoSelectBox,
    prepareRaikoSelectBoxItem,
    RaikoBaseCardContainer,
    RaikoPagination, RaikoSectionContainer
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {RaikoErrorSectionVectors} from "../../util/RaikoErrorSectionVectors";
import Pagination from "@mui/material/Pagination";
import FileManagerCardContainer
    from "../../component/fileManagerCard/fileManagerCardContainer/FileManagerCardContainer";
import FileManagerCard from "../../component/fileManagerCard/FileManagerCard";


export default function FileManager2(
    {
        buckets = fileManagers
    }) {

    let page = 0
    const size = 20

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [selectedBucketId, setSelectedBucketId] = useState("");
    const [filterItems, setFilterItems] = useState([]);

    const [itemsCount, setItemsCount] = useState(0);

    const [fileItems, setFileItems] = useState([]);
    const [fileManagerItemsLoadingState, setFileManagerItemsLoadingState] = useState(true);
    const [pageCount, setPageCount] = useState(0);

    const service = new FileManagerService()

    useEffect(() => {
        initialFilters()
    }, [buckets]);

    function initialFilters() {
        setFilterItems([])
        buckets.map((item, index) => {
            setFilterItems(prevState => [
                ...prevState,
                prepareRaikoSelectBoxItem(
                    item.id,
                    item.name
                )
            ])
        })

        setSelectedBucketId(buckets[0].id)
    }

    useEffect(() => {
        if (selectedBucketId && selectedBucketId.length > 0) {
            getFilesFromServer()
        }
    }, [selectedBucketId]);

    function getFilesFromServer() {
        setFileManagerItemsLoadingState(true)
        setItemsCount(0)

        service.getFiles(
            selectedBucketId,
            page, size
        ).then(response => {
            setPageCount(response.totalPage)
            setItemsCount(response.numberOfItems)
            setFileItems([])
            response.data.map((item, index) => {
                setFileItems(prev => [
                    ...prev,
                    {
                        name: item.metadata.fileName,
                        id: item.metadata.id,
                        size: item.metadata.size,
                        uploadedAt: item.metadata.uploadedAt,
                        uploadedBy: item.metadata.uploadedBy,
                        url: item.urls && item.urls.downloadUrl ? item.urls.downloadUrl : "",
                        stream: item.urls && item.urls.streamUrl ? item.urls.streamUrl : ""
                    }
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setFileManagerItemsLoadingState(false)
        })
    }

    function handleDeleteItemFromList(id) {
        const newMediaArray = []
        fileItems.map((item) => {
            if (item.id !== id) {
                newMediaArray.push(item)
            }
        })
        setFileItems(newMediaArray)

    }

    function detectFileType() {


        return fileItems.map((item, index) => {
            return <MediaItemsModel
                id={item.id}
                name={item.name}
                url={item.url}
                streamUrl={item.stream}
                size={item.size}
                uploadedAt={item.uploadedAt}
                uploadedBy={item.uploadedBy}
                type={FileManagerTypes[selectedBucketId].type}
                handleDeleteItemFromList={handleDeleteItemFromList}
                refreshList={_ => {
                    getFilesFromServer()
                }}
            />
        })
    }

    function detectFileTypeVersionTwo() {
        return fileItems.map((item, index) => {
            return <FileManagerCard
                key={index}
                id={item.id}
                name={item.name}
                url={item.url}
                streamUrl={item.stream}
                size={item.size}
                uploadedAt={item.uploadedAt}
                uploadedBy={item.uploadedBy}
                type={FileManagerTypes[selectedBucketId].type}
                handleDeleteItemFromList={handleDeleteItemFromList}
                refreshList={_ => {
                    getFilesFromServer()
                }}
            />
        })

    }

    const [uploadVideoDialog, setUploadVideoDialog] = useState(false);
    const [uploadAudioDialog, setUploadAudioDialog] = useState(false);
    const [uploadImageDialog, setUploadImageDialog] = useState(false);


    function handleUploadNewFile() {
        switch (FileManagerTypes[selectedBucketId].type) {
            case fileTypes.VIDEO:
                setUploadVideoDialog(true)
                break;
            case fileTypes.IMAGE:
                setUploadImageDialog(true)
                break;
            case fileTypes.AUDIO:
                setUploadAudioDialog(true)
                break;

        }
    }

    function handleRefreshList(newItem) {
        setItemsCount(itemsCount + 1)

        if (uploadImageDialog) {
            setUploadImageDialog(false)
            setFileItems(prev => [
                {
                    name: newItem.metadata.fileName,
                    id: newItem.metadata.id,
                    size: newItem.metadata.size,
                    uploadedAt: newItem.metadata.uploadedAt,
                    uploadedBy: newItem.metadata.uploadedBy,
                    url: newItem.url,
                },
                ...prev
            ])
        } else {
            setUploadVideoDialog(false)
            setUploadAudioDialog(false)

            setFileItems(prev => [
                {
                    name: newItem.metadata.fileName,
                    id: newItem.metadata.id,
                    size: newItem.metadata.size,
                    uploadedAt: newItem.metadata.uploadedAt,
                    uploadedBy: newItem.metadata.uploadedBy,
                    url: newItem.urls.streamUrl,
                },
                ...prev
            ])
        }
    }

    function handleChangePagination(event, value) {
        page = value - 1
        getFilesFromServer()
    }


    return (
        <>
            <Helmet>
                <title>{RouteHelper.Files.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    // page = 0
                    // getFilesFromServer()
                    setUploadAudioDialog(false)
                }}
                open={uploadAudioDialog}
                pageTitle={"بارگزاری صوت جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <UploadAudioFile handleRefreshList={handleRefreshList}/>

            </RaikoDefaultDialogPage>

            <RaikoDefaultDialogPage
                onClose={_ => {
                    // page = 0
                    // getFilesFromServer()
                    setUploadVideoDialog(false)
                }}
                open={uploadVideoDialog}
                pageTitle={"بارگزاری ویدیو جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <UploadVideoFile
                    handleRefreshList={handleRefreshList}
                    handleCloseDialog={_ => {
                        setUploadVideoDialog(false)
                    }}
                />

            </RaikoDefaultDialogPage>

            <RaikoDefaultDialogPage
                onClose={_ => {
                    // page = 0
                    // getFilesFromServer()
                    setUploadImageDialog(false)
                }}
                open={uploadImageDialog}
                pageTitle={"بارگزاری تصویر جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <UploadImageFile
                    handleRefreshList={handleRefreshList}
                    uploadUrl={selectedBucketId && selectedBucketId.length > 0 && FileManagerTypes[selectedBucketId] ? FileManagerTypes[selectedBucketId].uploadUrl : ""}/>

            </RaikoDefaultDialogPage>

            <RaikoBaseContainer className={"baseFileManagerContainer"}>

                <RaikoGridOneColumn className={css`gap: 2.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator("مجله", ""),
                        raikoBreadCrumbItemGenerator(selectedBucketId && selectedBucketId.length > 0 ? FileManagerTypes[selectedBucketId].name : "", ""),
                    ]}/>

                    <RaikoGridOneColumn>
                        <RaikoLabel text={"دسته ها"}/>
                        <RaikoSelectBox
                            changeSelectItem={setSelectedBucketId}
                            items={filterItems}
                            defaultSelectedItem={selectedBucketId}
                        />
                    </RaikoGridOneColumn>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"فایل ها"}
                                hasCreateNewItem
                                handleCreateNewItem={handleUploadNewFile}
                                amount={itemsCount}
                            />
                            <div className={css`
                                display: flex;
                                flex-wrap: wrap;
                                gap: 1rem;
                                width: 100%;
                                justify-content: center;
                            
                            `}>
                                {detectFileTypeVersionTwo()}
                            </div>
                            <div
                                className={css`
                                    width: 100%;
                                    display: flex;
                                    justify-content: center;
                                    align-content: center;
                                `}>
                                <Pagination
                                    count={pageCount}
                                    shape="rounded"
                                    onChange={handleChangePagination}
                                    className={pageCount && pageCount > 0 ? "" : css`display: none`}
                                />
                            </div>


                        </RaikoGridOneColumn>

                    </RaikoBaseCardContainer>


                    <RaikoTableTitleContainer
                        title={"فایل ها"}
                        hasCreateNewItem
                        handleCreateNewItem={handleUploadNewFile}
                        amount={itemsCount}
                    />

                    {
                        fileManagerItemsLoadingState ?
                            <MediaItemShimmer/> :
                            fileItems && fileItems.length > 0 && !fileManagerItemsLoadingState ?
                                <RaikoGridOneColumn className={css`gap: .75rem`}>
                                    {detectFileType()}
                                </RaikoGridOneColumn>
                                :
                                <RaikoErrorSection
                                    errorType={RaikoErrorSectionVectors.EMPTY_LIST_ONE}
                                    subTitle={""}
                                />
                    }

                    {
                        <div
                            className={css`
                                width: 100%;
                                display: flex;
                                justify-content: center;
                                align-content: center;
                            `}>
                            <Pagination
                                count={pageCount}
                                shape="rounded"
                                onChange={handleChangePagination}
                                className={pageCount && pageCount > 0 ? "" : css`display: none`}
                            />
                        </div>
                    }

                </RaikoGridOneColumn>

            </RaikoBaseContainer>

        </>
    )
}


const fileManagers = [
    FileManagerTypes.POST_THUMBNAILS,
    FileManagerTypes.POST_IMAGES,
    FileManagerTypes.VIDEO,
    FileManagerTypes.AUDIO,
    FileManagerTypes.PREDEFINED_AVATAR,
    // FileManagerTypes.APK,
]